import React from 'react'

import Layout from 'components/shared/Layout'
import CardsGrid from 'components/shared/CardsGrid'
import StoriesCardContent from 'components/shared/CardWithArrowLink/StoriesCardContent'
import Tetris from 'components/decorations/Tetris'

import { CardWithArrowLinkProps } from 'components/shared/CardWithArrowLink'
import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const StoriesGrid = ({ className, cards, decorationType, theme }) => {
  const customCardProps = CardWithArrowLinkProps.customCardProps

  return (
    <Layout className={cx(className, css.StoriesGrid)} type="maxWidth">
      <Layout type="wrapper">
        <Layout type="innerWrapper">
          {cards && cards.length > 0 && (
            <CardsGrid
              cards={cards}
              cover={{
                size: 'small',
              }}
              bottomLink
              customCardComponent={StoriesCardContent}
              customCardProps={{
                ...customCardProps,
                cover: { ...customCardProps.cover, size: 'small' },
              }}
            />
          )}
          <Tetris
            className={css.tetris}
            rotate={-90}
            theme={theme}
            type={decorationType}
          />
        </Layout>
      </Layout>
    </Layout>
  )
}

StoriesGrid.defaultProps = {
  theme: 'blue',
  decorationType: 'type4',
}

export default StoriesGrid
